import { FormattedMessage } from 'react-intl';
import type { Booking } from '../types';
import {
  BookingDate,
  BookingGuests,
  BookingName,
  CurrentBookingWrapper,
  ColumnHeader,
} from '../styles';

type CurrentBookingDisplayProps = {
  booking: Booking;
};

export const CurrentBookingDisplay = ({
  booking,
}: CurrentBookingDisplayProps) => {
  return (
    <CurrentBookingWrapper>
      <ColumnHeader>
        <FormattedMessage defaultMessage="Current booking:" />
      </ColumnHeader>
      <BookingName>{booking.guestName}</BookingName>
      <BookingGuests>{`${booking.numberOfGuests} ${booking.guestsDescriptor}`}</BookingGuests>
      <BookingDate>
        <FormattedMessage
          defaultMessage="{date} at {time}"
          values={{ date: booking.formattedDate, time: booking.formattedTime }}
        />
      </BookingDate>
    </CurrentBookingWrapper>
  );
};
